import IGenericResult from "../interfaces/IGenericResult";
import IPayload from "../interfaces/IPayload";
import IUsina from "../interfaces/IUsina";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";
class UsinaService {
    async create(data: any) {
        return await api.post<IUsina>(`${resources.usina}/Create`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.usina}/Update`, data);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.usina}/Delete/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.usina}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getUsinas() {
        return await api.get<IGenericResult[]>(`${resources.usina}/GetAllUsinas`);
    }
}

export default new UsinaService();
